<template>
  <div>
    <div class="page-title">用户管理</div>

    <el-form
      :model="searchForm"
      class="form"
      inline
      label-width="80px"
      @submit.native.prevent
    >
      <el-form-item label="用户名">
        <el-input v-model.trim="searchForm.name" placeholder="输入用户名精确搜索" @keypress.native.enter="handleSearch"></el-input>
      </el-form-item>
      <el-form-item label="公司名">
        <el-input v-model.trim="searchForm.companyName" placeholder="输入公司名精确搜索" @keypress.native.enter="handleSearch"></el-input>
      </el-form-item>
      <el-form-item label="邮箱">
        <el-input v-model.trim="searchForm.email" placeholder="请输入邮箱" @keypress.native.enter="handleSearch"></el-input>
      </el-form-item>
      <el-form-item label="用户类型">
        <el-select v-model="searchForm.roleType" clearable placeholder="请选择用户类型">
          <el-option
            v-for="(name,code) in roleTypeMap"
            :key="code"
            :label="name"
            :value="+code"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="QQ号">
        <el-input v-model.trim="searchForm.qqNum" placeholder="请输入QQ号" @keypress.native.enter="handleSearch"></el-input>
      </el-form-item>
      <el-button type="primary" @click="handleSearch" :loading="searching">查 询</el-button>
    </el-form>

    <el-card>
      <el-table :data="userList" v-loading="searching">
        <el-table-column label="用户名" prop="name"></el-table-column>
        <el-table-column label="用户类型" v-slot="{ row }" width="100">
          {{ roleTypeMap[row.roleType] }}
        </el-table-column>
        <el-table-column label="是否签约" v-slot="{ row }" width="70">
          {{ row.company ? switchMap[row.company.signStatus] : '-' }}
        </el-table-column>
        <el-table-column label="公司名" prop="company.companyName"></el-table-column>
        <el-table-column label="邮箱" prop="company.email"></el-table-column>
        <el-table-column label="QQ号" prop="company.qqNum" width="100"></el-table-column>
        <el-table-column label="关联商务" v-slot="{ row }">
          {{ row.business ? row.business.userName : '' }}
        </el-table-column>
        <el-table-column label="商务邮箱" v-slot="{ row }">
          {{ row.business ? row.business.email : '' }}
        </el-table-column>
        <el-table-column
          label="状态"
          prop="isActive"
          width="60"
          :filters="[{ text: '停用', value: false }, { text: '启用', value: true }]"
          :filter-method="filterStatus"
        >
          <template slot-scope="{ row }">
            <el-tag :type="row.isActive ? 'success' : 'danger'">
              {{ activeMap[row.isActive ? 1 : 0] }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="所属用户组" v-slot="{ row }">
          {{ row.userGroupList.join('|') }}
        </el-table-column>
        <el-table-column label="注册时间" v-slot="{ row }">
          {{ row.dateJoined }}
        </el-table-column>
        <el-table-column label="操作" width="50">
          <template slot-scope="{ row }">
            <el-button v-if="row.isActive" type="text" @click="handleDeactive(row)">查看</el-button>
            <el-button v-else type="text" @click="handleShowDialog(row)">审核</el-button>
          </template>
        </el-table-column>
      </el-table>
      <br>
      <el-pagination
        @size-change="handleSearch"
        @current-change="fetchUsers"
        :current-page.sync="pagination.current"
        :page-size.sync="pagination.size"
        :total="pagination.total"
        :page-sizes="[10, 20, 50, 100, 500]"
        layout="total, sizes, prev, pager, next, jumper"
        class="pagination"
      >
      </el-pagination>
    </el-card>

    <!-- 审核弹窗 -->
    <el-dialog
      v-if="editRow"
      title="审核用户"
      v-draggable
      @close="handleDialogClose"
      width="700"
      :visible.sync="dialogShow"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form :model="editRow" label-width="140px">
        <!-- 第三方组织/个人 -->
        <template v-if="isAppeal">
          <template v-if="isOrganization">
            <el-form-item label="组织机构名称：">
              {{ editRow.company.companyName }}
            </el-form-item>
            <el-form-item label="统一社会信用代码：">
              {{ editRow.company.socialCreditCode }}
            </el-form-item>

            <el-form-item label="组织机构存续证明：">
              <img :src="editRow.company.firstLicenseUrl" style="width: 200px;height: 200px">
            </el-form-item>
            <el-form-item label="法人代表：">
              {{ editRow.company.corporation }}
            </el-form-item>

            <el-form-item label="联系人姓名：">
              {{ editRow.company.name }}
            </el-form-item>
          </template>

          <template v-if="isPrivate">
            <el-form-item label="真实姓名：">
              {{ editRow.company.companyName }}
            </el-form-item>
            <el-form-item label="证件类型：">
              {{ IDTypeMap[editRow.company.idCodeType] }}
            </el-form-item>

            <el-form-item label="证件号码：">
              {{ editRow.company.idCode }}
            </el-form-item>

            <el-form-item label="证件正面照片：">
              <img class="identify_pic" :src="editRow[ID_FILE_KEY_TYPE_ENUM.FRONT.name].fileUrl" style="width: 250px;height: 200px">
            </el-form-item>
            <el-form-item label="证件反面照片：">
              <img class="identify_pic" :src="editRow[ID_FILE_KEY_TYPE_ENUM.BACK.name].fileUrl" style="width: 250px;height: 200px">
            </el-form-item>
            <el-form-item label="证件手持照片：">
              <img class="identify_pic" :src="editRow[ID_FILE_KEY_TYPE_ENUM.HAND.name].fileUrl" style="width: 250px;height: 200px">
            </el-form-item>
          </template>

          <el-form-item label="联系人电话：">
            {{ editRow.company.phoneNum }}
          </el-form-item>
          <el-form-item label="联系人邮箱：">
            {{ editRow.company.email }}
          </el-form-item>
          <el-form-item label="联系人地址：">
            {{ editRow.company.cpAddress }}
          </el-form-item>
          <el-form-item label="邮政编码：" v-if="isOrganization">
            {{ editRow.company.postalcode }}
          </el-form-item>
          <el-form-item label="QQ号码：">
            {{ editRow.company.qqNum }}
          </el-form-item>
        </template>

        <!-- AI发行 -->
        <template v-else-if="isAIPublish">
          <el-form-item label="手机号：">
            {{ editRow.singer.phoneNum }}
          </el-form-item>
          <el-form-item label="账号名称：">
            {{ editRow.singer.singerName }}
          </el-form-item>
          <el-form-item label="头像：">
            <ul>
              <li v-for="(item, index) in editRow.singer.singerPhotoList" :key="index">
                <img :src="item.photoUrl" style="width:150px;height:150px">
              </li>
            </ul>
          </el-form-item>
          <el-form-item label="QQ：">
            {{ editRow.singer.qqNum }}
          </el-form-item>
          <el-form-item label="微信：">
            {{ editRow.singer.wechat }}
          </el-form-item>
        </template>

        <template v-else>
          <el-form-item v-if="!needCompanyInfo && !isAppeal" label="企业微信名：" prop="rtxName">
            {{ editRow.editor.rtxName }}
          </el-form-item>
          <el-form-item v-if="needCompanyInfo" label="公司LOGO：">
            <img :src="editRow.company.companyPhotoList[0].url" style="width: 200px;height: 200px">
          </el-form-item>
          <el-form-item v-if="needCompanyInfo" label="公司名：">
            {{ editRow.company.companyName }}
          </el-form-item>
          <el-form-item v-if="needCompanyInfo" label="法人代表：">
            {{ editRow.company.corporation }}
          </el-form-item>
          <el-form-item v-if="needCompanyInfo" label="公司地址：">
            {{ editRow.company.cpAddress }}
          </el-form-item>
          <el-form-item label="公司邮箱：">
            {{ needCompanyInfo ? editRow.company.email : editRow.editor.email }}
          </el-form-item>
          <el-form-item label="公司电话：">
            {{ needCompanyInfo ? editRow.company.phoneNum : editRow.editor.phoneNum }}
          </el-form-item>
          <el-form-item label="QQ号：">
            {{ needCompanyInfo ? editRow.company.qqNum : editRow.editor.qqNum }}
          </el-form-item>
          <el-form-item v-if="needCompanyInfo" label="公司描述：">
            {{ editRow.company.companyDesc }}
          </el-form-item>
          <el-form-item v-if="needCompanyInfo" label="营业执照：">
            <div v-for="license in editRow.company.companyLicenseList" :key="license.url">
              <a :href="license.url" target="_blank">{{ license.fileName }}</a>
            </div>
          </el-form-item>
          <el-form-item v-if="needCompanyInfo" label="签约状态：">
            {{ needCompanyInfo && signStatusMap[editRow.company.signStatus] }}
          </el-form-item>
          <el-form-item v-if="needCompanyInfo" label="作品信息：">
            <div v-for="product in editRow.company.productionList" :key="product.fileUrl">
              <a :href="product.fileUrl" :download="product.fileName">{{ product.fileName }}</a>
            </div>
          </el-form-item>

          <template v-if="needCompanyInfo">
            <el-row>
              <el-col :span="12">
                <el-form-item label="公司ID：">
                  <el-input v-model="companyId" placeholder=""></el-input>
                </el-form-item>
              </el-col>
              <el-col v-if="editRow.copyrightCompany && editRow.copyrightCompany.cpCompanyName" :span="24">
                <el-form-item label="所属版权公司：">
                  {{ editRow.copyrightCompany.cpCompanyName }}
                  <el-input v-model="editRow.copyrightCompany.cpCompanyId" placeholder="输入版权公司ID"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="editRow.agentCompanyList.length">
              <el-form-item label="代理厂牌：">
                <ul>
                  <li v-for="item in editRow.agentCompanyList" :key="item.tempId">
                    {{ item.agentCompanyName }}：
                    <el-input v-model="item.agentCompanyId" placeholder="输入代理厂牌库内公司ID"></el-input>
                  </li>
                </ul>
              </el-form-item>
            </el-row>
          </template>
          <el-row v-if="editRow.roleType === ROLE_TYPE_ENUM.BUSINESS.code">
            <el-form-item label="关联厂牌：">
              <ul>
                <li v-for="item in editRow.relateCompanyList" :key="item.tempId">
                  {{ item.relateCompanyName }}：
                  <el-input v-model="item.relateCompanyId" placeholder="输入关联厂牌库内公司ID"></el-input>
                </li>
              </ul>
            </el-form-item>
          </el-row>
          <el-row v-if="needCompanyInfo">
            <el-col :span="12">
              <el-form-item label="商务名字：">
                <el-input v-model="userName" placeholder=""></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="商务邮箱：">
                <el-input v-model="email" placeholder=""></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </template>

        <!-- 审核信息 -->
        <el-row>
          <el-col :span="12">
            <el-form-item label="审核信息：">
              <el-input v-model="checkInfo" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="数据权限：">
              <el-select
                v-model="isShowAll"
                placeholder="请选择数据查看权限"
                style="width: 100%"
              >
                <el-option
                  v-for="(label, value) in dataShowPermMap"
                  :value="+value"
                  :key="+value"
                  :label="label"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="内容管理权限：">
              <el-select
                v-model="showType"
                placeholder="请选择数据查看权限"
                style="width: 100%"
              >
                <el-option
                  v-for="(label, value) in contentShowPermMap"
                  :value="+value"
                  :key="+value"
                  :label="label"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button type="ghost" :loading="btnLoading" @click="handleDialogClose">取 消</el-button>
        <el-button type="danger" :loading="btnLoading" @click="handleReject">
          {{ editRow.isActive ? '停 用' : '拒 绝' }}
        </el-button>
        <el-button type="primary" :loading="btnLoading" @click="handlePass">
          {{ editRow.isActive ? '修 改' : '通 过' }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import cloneDeep from 'lodash-es/cloneDeep'
import { MessageBox } from 'element-ui'
import authService from '@/api/auth'
import { switchMap } from '@/utils/constants'
import { ROLE_TYPE_ENUM, SIGN_STATUS, ID_FILE_KEY_TYPE_ENUM, IDTypeMap, singerTypeMap } from '@/views/person/const'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { areaMap, genreMap } from '@/views/singer/mixin'

dayjs.extend(customParseFormat)

export default {
  name: 'UserList',
  data() {
    return {
      ROLE_TYPE_ENUM,
      isShowAll: 0,
      showType: 0,
      roleTypeMap: ROLE_TYPE_ENUM.codeNameMap,
      signStatusMap: SIGN_STATUS.codeNameMap,
      switchMap,
      IDTypeMap,
      ID_FILE_KEY_TYPE_ENUM,
      areaMap,
      genreMap,
      singerTypeMap,

      userList: [],
      dialogShow: false,
      btnLoading: false,
      searching: false,
      editRow: null,
      companyMap: {
        0: 'QQ音乐',
        1: '酷狗音乐',
        2: '酷我音乐',
        3: '中央曲库'
      },
      dataShowPermMap: {
        0: '厂牌自助平台上传数据',
        1: '厂牌签约全量数据',
        2: '不可见',
        3: '个人自助平台上传工具'
      },
      activeMap: {
        0: '停用',
        1: '启用'
      },
      contentShowPermMap: {
        0: '无',
        1: '数字音乐平台上传数据',
        2: '曲库全量数据'
      },
      companyId: '',
      userName: '',
      email: '',
      checkInfo: '',
      pagination: {
        current: 1,
        size: 20,
        total: 0
      },
      searchForm: {
        name: '',
        companyName: '',
        email: '',
        roleType: void 0,
        qqNum: ''
      }
    }
  },
  computed: {
    needCompanyInfo() {
      return this.editRow ? [ROLE_TYPE_ENUM.COMPANY.code, ROLE_TYPE_ENUM.OTHER.code].includes(this.editRow.roleType) : false
    },

    isOrganization() {
      return this.editRow?.roleType === ROLE_TYPE_ENUM.ORGANIZATION.code
    },

    isPrivate() {
      return this.editRow?.roleType === ROLE_TYPE_ENUM.PRIVATE.code
    },

    isAppeal() {
      return this.isOrganization || this.isPrivate
    },

    isAIPublish() {
      return this.editRow?.roleType === ROLE_TYPE_ENUM.AI_PUBLISH.code
    }
  },
  created() {
    this.handleSearch()
  },
  methods: {
    fetchUsers() {
      const { pagination, searchForm } = this.$data
      this.searching = true
      const searchData = { ...searchForm }
      Object.keys(searchData).forEach(key => {
        if (searchData[key] === '') {
          searchData[key] = undefined
        }
      })

      authService.queryUser({
        page: pagination.current - 1,
        num: pagination.size,
        ...searchData,
      }).then(resp => {
        this.pagination.total = resp.total
        this.userList = resp.list.map(item => {
          if (item.company) {
            item.company.companyLicenseList.forEach(item => {
              item.url = this.$toPreview(item.photoUrl)
            })
            item.company.firstLicenseUrl = item.company.companyLicenseList[0]?.url
            item.company.companyPhotoList.forEach(item => {
              item.url = this.$toPreview(item.photoUrl)
            })
            item.copyrightCompany = item.copyrightCompanyList[0]

            if (item.company.businessList.length) {
              item.business = item.company.businessList[0]
            }
          }
          for (const rc of item.relateCompanyList) {
            rc.realteCompanyId = rc.realteCompanyId || ''
          }
          for (const ac of item.agentCompanyList) {
            ac.agentCompanyId = ac.agentCompanyId || ''
          }
          if (item.dateJoined) {
            item.dateJoined = dayjs(item.dateJoined).format('MM/DD/YYYY')
          }

          return item
        })
      }).catch(error => {
        console.error(error)
        this.$message({
          type: 'error',
          message: '查询用户列表异常.' + error.message,
        })
      }).finally(_ => {
        this.searching = false
      })
    },

    handleShowDialog(row) {
      this.editRow = cloneDeep(row)
      if (this.isAIPublish) {
        this.isShowAll = +row.singer.isShowAll
        this.showType = +row.singer.showType
      } else if (this.needCompanyInfo || this.isAppeal) {
        this.isShowAll = +row.company.isShowAll
        this.showType = +row.company.showType
      } else {
        this.isShowAll = +row.editor.isShowAll
        this.showType = +row.editor.showType
      }

      // 处理证件照片
      if (this.isPrivate) {
        this.editRow.identifyList.forEach(file => {
          const type = ID_FILE_KEY_TYPE_ENUM.codeNameMap[file.fileType]
          file.name = file.fileName
          this.editRow[type] = file
        })
      }

      this.dialogShow = true
    },

    filterStatus(value, row, column) {
      return row[column.property] === value
    },

    handleDialogClose() {
      this.dialogShow = false
      this.reset()
    },

    handleDeactive(row) {
      this.editRow = cloneDeep(row)
      if (this.isAIPublish) {
        const singer = row.singer
        this.isShowAll = singer.isShowAll
        this.showType = singer.showType
        this.checkInfo = singer.checkInfo
      } else if (this.needCompanyInfo || this.isAppeal) {
        const userCompany = row.company
        const business = row.business
        this.isShowAll = +userCompany.isShowAll
        this.showType = +userCompany.showType
        this.companyId = userCompany.companyId
        this.userName = business.userName
        this.email = business.email
        this.checkInfo = userCompany.checkInfo
      } else {
        const editor = row.editor
        this.isShowAll = +editor.isShowAll
        this.showType = +editor.showType
        this.checkInfo = editor.checkInfo
      }

      if (this.isPrivate) {
        this.editRow.identifyList.forEach(file => {
          const type = ID_FILE_KEY_TYPE_ENUM.codeNameMap[file.fileType]
          file.name = file.fileName
          this.editRow[type] = file
        })
      }

      this.dialogShow = true
    },

    handleReject() {
      const { checkInfo, editRow } = this

      if (!checkInfo) {
        return this.$message({
          type: 'warning',
          message: '请填写审核信息'
        })
      }

      this.toggleActive({
        active: 0,
        companyId: 0,
        checkInfo,
        businessList: [],
        relateCompanyList: editRow.relateCompanyList,
        agentCompanyList: editRow.agentCompanyList,
        copyrightCompanyList: editRow.copyrightCompanyList,
        userId: editRow.id,
        singerId: editRow.singer?.singerId
      })
    },

    handlePass() {
      const { checkInfo, companyId, userName, email, editRow, needCompanyInfo } = this
      if (!checkInfo.trim()) {
        return this.$message({
          type: 'warning',
          message: '请填写审核信息'
        })
      }

      if (needCompanyInfo) {
        if (!companyId) {
          return this.$message({
            type: 'warning',
            message: '请填写公司ID'
          })
        }
        if (!userName) {
          return this.$message({
            type: 'warning',
            message: '请填写商务名字'
          })
        }
        if (!email) {
          return this.$message({
            type: 'warning',
            message: '请填写商务邮箱'
          })
        }

        for (const cp of editRow.relateCompanyList) {
          if (!cp.relateCompanyId || isNaN(Number(cp.relateCompanyId))) {
            return this.$message({
              type: 'warning',
              message: `请填写关联厂牌（${cp.relateCompanyName}）关联的公司 ID`
            })
          }
        }
        for (const cp of editRow.agentCompanyList) {
          if (!cp.agentCompanyId || isNaN(Number(cp.agentCompanyId))) {
            return this.$message({
              type: 'warning',
              message: `请填写代理厂牌（${cp.agentCompanyName}）关联的公司 ID`
            })
          }
        }
      }

      this.toggleActive({
        active: 1,
        companyId: needCompanyInfo ? +companyId : 0,
        businessList: [
          {
            userName,
            email,
          }
        ],
        isShowAll: this.isShowAll,
        showType: this.showType,
        relateCompanyList: editRow.relateCompanyList,
        checkInfo,
        copyrightCompanyList: editRow.copyrightCompanyList,
        agentCompanyList: editRow.agentCompanyList,
        userId: editRow.id,
        singerId: editRow.singer?.singerId
      })
    },

    handleToGroup() {
      MessageBox.close()
      this.$router.push({ name: 'userGroupList' })
    },

    toggleActive(postData) {
      this.btnLoading = true
      authService.activate(postData).then(resp => {
        this.$message.success(postData.active ? '启用成功' : '停用成功')
        // this.editRow.isActive = !this.editRow.isActive
        this.fetchUsers()

        if (postData.active) {
          // 启用的话，提示授权
          this.$msgbox({
            title: '提示',
            showConfirmButton: false,
            showCancelButton: true,
            cancelButtonText: '关 闭',
            message: (
              <p>是否需要立刻给用户授权?<el-button type="text" on-click={this.handleToGroup}>前往授权</el-button></p>
            )
          })
        }
      }).catch(error => {
        console.error(error)
        this.$message({
          type: 'error',
          message: `${postData.active ? '启用失败' : '停用失败'}(${error.message})`,
          duration: 5000
        })
      }).finally(_ => {
        this.btnLoading = false
        this.dialogShow = false
      })
    },

    handleSearch() {
      this.pagination.current = 1

      this.fetchUsers()
    },

    reset() {
      this.isShowAll = 0
      this.showType = 0
      this.companyId = ''
      this.userName = ''
      this.email = ''
      this.checkInfo = ''
    }
  }
}
</script>

<style scope lang="scss">
.identify_pic {
  object-fit: contain;
}
</style>
